import React from 'react';
import { useNavigate } from 'react-router-dom';

const ReturnPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="page-content">
      <div className="policy-page">
        <button 
          className="btn outline" 
          onClick={() => navigate(-1)}
          style={{ marginBottom: '2rem' }}
        >
          ← Back
        </button>
        
        <div className="policy-header">
          <h1 className="policy-title">🔁 Return & Refund Policy</h1>
          <p className="policy-date">Effective Date: January 14, 2025</p>
        </div>
        
        <div className="policy-content">
          <div className="policy-section">
            <p>At NeoTeeForge, we want you to be completely satisfied with your purchase. This policy outlines our procedures for returns, exchanges, and refunds.</p>
          </div>

          <div className="policy-section">
            <h3>📱 Digital Products Policy</h3>
            <div style={{ 
              background: '#fef2f2', 
              padding: '1.5rem', 
              borderRadius: '12px',
              marginBottom: '1.5rem',
              borderLeft: '4px solid #dc2626'
            }}>
              <h4 style={{ color: '#dc2626', marginTop: 0 }}>Important:</h4>
              <p><strong>No returns or refunds are available for digital products once they have been downloaded or accessed.</strong></p>
              <p>This includes:</p>
              <ul className="policy-list">
                <li>eBooks and digital books</li>
                <li>PDF downloads</li>
                <li>Digital templates and printables</li>
                <li>Online course access</li>
                <li>Software or app downloads</li>
              </ul>
            </div>
            
            <h4>Why this policy exists:</h4>
            <ul className="policy-list">
              <li>Digital products cannot be "returned" once accessed</li>
              <li>To prevent unauthorized sharing and piracy</li>
              <li>To maintain the value of intellectual property</li>
            </ul>
            
            <h4>What you can do:</h4>
            <ul className="policy-list">
              <li>Review product descriptions, samples, and previews carefully before purchase</li>
              <li>Check system requirements for digital products</li>
              <li>Contact us with any questions before purchasing</li>
              <li>Use our "Contact Us" page for product inquiries</li>
            </ul>
            
            <h4>Exceptions (Case-by-case basis):</h4>
            <p>We may consider refunds for digital products only if:</p>
            <ul className="policy-list">
              <li>The product is completely different from its description</li>
              <li>The file is corrupted and cannot be opened (with proof)</li>
              <li>You haven't downloaded or accessed the product</li>
              <li>Technical issues prevent access that we cannot resolve</li>
            </ul>
          </div>

          <div className="policy-section">
            <h3>📦 Physical Products Return Policy</h3>
            <p>For physical books and merchandise, returns are accepted under the following conditions:</p>
            
            <div style={{ 
              background: '#f0f9ff', 
              padding: '1.5rem', 
              borderRadius: '12px',
              margin: '1.5rem 0'
            }}>
              <h4 style={{ color: '#0369a1', marginTop: 0 }}>✅ Acceptable Reasons for Return:</h4>
              <ul className="policy-list">
                <li><strong>Damaged or defective product</strong> received</li>
                <li><strong>Wrong item</strong> shipped (different from what was ordered)</li>
                <li>Product with <strong>missing pages or content</strong></li>
                <li><strong>Significant quality issues</strong> not matching description</li>
              </ul>
              
              <h4 style={{ color: '#dc2626', marginTop: '1rem' }}>❌ Non-Returnable Items:</h4>
              <ul className="policy-list">
                <li>Products damaged due to customer mishandling</li>
                <li>Items returned without original packaging</li>
                <li>Personalized or custom-made products</li>
                <li>Products purchased on sale or clearance</li>
                <li>Opened audio/video products (CDs, DVDs)</li>
              </ul>
            </div>
          </div>

          <div className="policy-section">
            <h3>⏰ Return Timeframe</h3>
            <div style={{ 
              background: '#fef3c7', 
              padding: '1rem', 
              borderRadius: '8px',
              marginBottom: '1rem'
            }}>
              <p><strong>Return requests must be raised within 7 days of delivery.</strong></p>
            </div>
            
            <ul className="policy-list">
              <li>Day 1 is counted from the delivery date shown on tracking</li>
              <li>Weekends and holidays are included in the 7-day period</li>
              <li>Late requests will not be accepted</li>
              <li>Contact us immediately upon receiving a damaged/wrong item</li>
            </ul>
          </div>

          <div className="policy-section">
            <h3>📝 Return Process</h3>
            <h4>Step 1: Contact Us</h4>
            <ul className="policy-list">
              <li>Email: support@neoteeforge.com with subject "Return Request - [Order Number]"</li>
              <li>Include your order number and reason for return</li>
              <li>We will respond within 24 business hours</li>
            </ul>
            
            <h4>Step 2: Provide Proof</h4>
            <ul className="policy-list">
              <li>Photos of the damaged/defective product (clear, well-lit)</li>
              <li>Photos of the packaging if damaged</li>
              <li>Video showing the issue (if applicable)</li>
              <li>Comparison with what was ordered</li>
            </ul>
            
            <h4>Step 3: Get Return Authorization</h4>
            <ul className="policy-list">
              <li>We will review your request and evidence</li>
              <li>If approved, we'll issue a Return Authorization Number</li>
              <li>Follow the instructions for returning the item</li>
              <li>Do not return items without authorization</li>
            </ul>
            
            <h4>Step 4: Ship the Item Back</h4>
            <ul className="policy-list">
              <li>Use the provided return shipping label (if applicable)</li>
              <li>Pack the item securely in original packaging</li>
              <li>Include all accessories, manuals, and freebies</li>
              <li>Get a tracking number for your return shipment</li>
            </ul>
          </div>

          <div className="policy-section">
            <h3>💰 Refund Process</h3>
            <h4>Refund Methods:</h4>
            <ul className="policy-list">
              <li><strong>Original Payment Method:</strong> Refunds are issued to the original payment method</li>
              <li><strong>Store Credit:</strong> Option to receive store credit for future purchases</li>
              <li><strong>Bank Transfer:</strong> For certain payment methods</li>
            </ul>
            
            <h4>Refund Timeline:</h4>
            <div style={{ 
              background: '#f0fdf4', 
              padding: '1rem', 
              borderRadius: '8px',
              margin: '1rem 0'
            }}>
              <ul className="policy-list">
                <li><strong>Upon approval:</strong> 1-2 business days to process refund</li>
                <li><strong>Credit Card/Payments:</strong> 5-10 business days to reflect in your account</li>
                <li><strong>Bank Transfer:</strong> 3-7 business days</li>
                <li><strong>Store Credit:</strong> Instant upon approval</li>
              </ul>
            </div>
            
            <h4>Deductions:</h4>
            <p>The following may be deducted from your refund:</p>
            <ul className="policy-list">
              <li>Return shipping costs (unless we made an error)</li>
              <li>Restocking fees for opened non-defective items (20%)</li>
              <li>Original shipping charges (non-refundable for non-defective returns)</li>
            </ul>
          </div>

          <div className="policy-section">
            <h3>🔄 Exchanges</h3>
            <p>We offer exchanges for:</p>
            <ul className="policy-list">
              <li>Wrong size/color (if available)</li>
              <li>Damaged/defective item for the same item</li>
              <li>Store credit for a different product</li>
            </ul>
            
            <p><strong>Exchange Process:</strong> Same as return process. You'll receive the replacement once we receive the returned item.</p>
          </div>

          <div className="policy-section">
            <h3>⚠️ Important Conditions</h3>
            <div style={{ 
              background: '#fef2f2', 
              padding: '1rem', 
              borderRadius: '8px',
              borderLeft: '4px solid #dc2626'
            }}>
              <ul className="policy-list">
                <li>Items must be in original condition with all tags attached</li>
                <li>Original packaging must be included</li>
                <li>Proof of purchase (order number) is required</li>
                <li>We reserve the right to reject returns that don't meet policy requirements</li>
                <li>Fraudulent return attempts will result in account termination</li>
              </ul>
            </div>
          </div>

          <div className="policy-section">
            <h3>📞 Contact for Returns</h3>
            <div style={{ 
              background: '#f8fafc', 
              padding: '1.5rem', 
              borderRadius: '12px',
              marginTop: '1rem'
            }}>
              <p><strong>For return requests and questions:</strong></p>
              <p><strong>📧 Email:</strong> support@neoteeforge.com</p>
              <p><strong>⏰ Business Hours:</strong> Monday-Friday, 9 AM - 6 PM IST</p>
              <p><strong>📋 Include in Subject:</strong> "Return Request - Order #[Your Order Number]"</p>
            </div>
          </div>

          <div style={{ 
            marginTop: '3rem', 
            paddingTop: '2rem', 
            borderTop: '1px solid #e2e8f0',
            background: '#f0f9ff',
            padding: '1.5rem',
            borderRadius: '12px'
          }}>
            <h4 style={{ color: '#0369a1', marginTop: 0 }}>💡 Before You Buy:</h4>
            <ul className="policy-list">
              <li>Read product descriptions carefully</li>
              <li>Check size charts and specifications</li>
              <li>View product images and videos</li>
              <li>Read customer reviews</li>
              <li>Contact us with any pre-purchase questions</li>
              <li>Save your order confirmation email</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnPolicy;